import { createContainer } from 'unstated-next'
import { useCallback, useState } from 'react'

const GroupRegistrationStore = createContainer(() => {
  const [selBatch, setSelBatch] = useState(null)
  const [activeStep, setActiveStep] = useState(0)
  const [videoBlob, setVideoBlob] = useState(null)
  const [message, setMessage] = useState('')

  const next = useCallback(() => setActiveStep((prevStep) => prevStep + 1), [])
  const back = useCallback(() => setActiveStep((prevStep) => prevStep - 1), [])

  return {
    selBatch,
    setSelBatch,
    activeStep,
    setActiveStep,
    videoBlob,
    setVideoBlob,
    message,
    setMessage,
    next,
    back,
  }
})

export default GroupRegistrationStore
